"use strict";

function open_filemanager_popup(field_id, fldr, relative) {
  var w = 880;
  var h = 570;
  var l = Math.floor((screen.width - w) / 2);
  var t = Math.floor((screen.height - h) / 2);
  var params = jQuery.param({
    popup: 1,
    lang: _APP.currentlanguage.code,
    relative_url: relative ? 1 : 0,
    fldr: fldr,
    field_id: field_id
  });
  var url = _APP.weburlprefix + '/filemanager/dialog.php?' + params;
  window.open(url, null, "scrollbars=1,width=" + w + ",height=" + h + ",top=" + t + ",left=" + l);
}

function responsive_filemanager_callback(field_id) {
  jQuery('#' + field_id).trigger('change');
}